import { SVGProps } from 'react'

export const ChatMobileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="40" height="40" rx="20" fill="#00A4FF" />
    <g clipPath="url(#clip0_17948_9868)">
      <path
        d="M15.5708 19.4216C15.5242 19.1212 15.5 18.8134 15.5 18.5C15.5 15.1863 18.2039 12.5 21.5394 12.5C24.875 12.5 27.5789 15.1863 27.5789 18.5C27.5789 19.2486 27.4409 19.9651 27.1889 20.6259C27.1365 20.7631 27.1103 20.8317 27.0984 20.8853C27.0867 20.9384 27.0821 20.9757 27.0808 21.0301C27.0796 21.0849 27.087 21.1454 27.1019 21.2662L27.4038 23.7189C27.4365 23.9844 27.4528 24.1172 27.4087 24.2137C27.37 24.2982 27.3012 24.3654 27.2158 24.4021C27.1183 24.4441 26.986 24.4247 26.7213 24.3859L24.3323 24.0357C24.2076 24.0174 24.1452 24.0083 24.0884 24.0086C24.0322 24.0089 23.9934 24.013 23.9384 24.0246C23.8828 24.0363 23.8118 24.0629 23.6697 24.1161C23.0073 24.3642 22.2893 24.5 21.5394 24.5C21.2258 24.5 20.9177 24.4762 20.617 24.4305M16.7237 27.5C18.9474 27.5 20.75 25.6532 20.75 23.375C20.75 21.0968 18.9474 19.25 16.7237 19.25C14.5 19.25 12.6974 21.0968 12.6974 23.375C12.6974 23.8329 12.7702 24.2735 12.9047 24.685C12.9615 24.859 12.9899 24.946 12.9992 25.0055C13.009 25.0675 13.0107 25.1023 13.0071 25.165C13.0036 25.2251 12.9886 25.293 12.9585 25.4287L12.5 27.5L14.7461 27.1932C14.8687 27.1765 14.93 27.1681 14.9835 27.1685C15.0399 27.1689 15.0698 27.1719 15.1251 27.183C15.1776 27.1934 15.2556 27.221 15.4117 27.276C15.8229 27.4212 16.2643 27.5 16.7237 27.5Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_17948_9868">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(11 11)"
        />
      </clipPath>
    </defs>
  </svg>
)
